import { useState, FormEvent } from 'react'
import Text from '../../common/Text'
import Input from '../../common/Input'
import TouchableOpacity from '../../common/TouchableOpacity'
import { useAuth } from '../../provider/authentication'
import { login } from '../../api/endpoints'
import styles from './style'

function Login() {
  const { setAccessToken } = useAuth()
  const [requestLoading, setRequestLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const [username, setUsername] = useState<string>()
  const [password, setPassword] = useState<string>()

  const submitLogin = () => {
    setRequestLoading(true)
    login(username, password).then(result => {
      setRequestLoading(false)
      if (!result.ok) {
        setErrorMessage('Login failed')
        return
      }
      if ('token' in result.data) {
        setAccessToken(result.data.token)
      } else {
        setErrorMessage(result.data.error)
      }
    })
  }

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (!requestLoading) submitLogin()
  }

  return (
    <div style={styles.container}>
      <form
        style={styles.card}
        onSubmit={onSubmit}
      >
        {/* Invisible default submit button so pressing Enter in a field submits the form. */}
        <button
          type='submit'
          style={{ display: 'none' }}
        />

        <div style={styles.titleRow}>
          <Text style={styles.title}>Expostreamer</Text>
        </div>

        <div style={styles.divider} />

        <Input
          autoCorrect={'on'}
          autoComplete={'username'}
          name={'username'}
          placeholder={'Benutzername'}
          setText={setUsername}
          type={'text'}
          required
        />

        <Input
          autoCorrect={'on'}
          autoComplete={'current-password'}
          name={'password'}
          placeholder={'Passwort'}
          setText={setPassword}
          type={'password'}
          required
        />

        <div style={styles.divider} />

        <div
          style={{
            ...styles.footerRow,
            justifyContent: errorMessage ? 'space-between' : 'flex-end',
          }}
        >
          {errorMessage ? <Text>{errorMessage}</Text> : null}
          <TouchableOpacity
            disabled={requestLoading}
            onClick={submitLogin}
          >
            <Text>Anmelden</Text>
          </TouchableOpacity>
        </div>
      </form>
    </div>
  )
}

export default Login
